import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import FormHeader from '@/components/ui/organisms/MHeader';
import { getMemberInfo } from '@/hooks/useMembers';
import { MInputField } from '@/components/ui/atoms/MInputField';
import { IconCaretDownFilled } from '@tabler/icons-react';
import MDropDownDrawer from '@/components/ui/molecules/MDropDownDrawer';
import { MButton } from '@/components/ui/atoms/MButtons';
import { RelationshipType, relationshipOptionsForAddMember } from '@/types/relationship';
import MSpacer from '@/components/ui/atoms/MSpacer';

type AddMemberForm = { relationship?: RelationshipType | '' };

const SelectRelationship: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  // Remove selectedRelationship state, use relationship as source of truth

  const navigate = useNavigate();

  const memberInfo = getMemberInfo(true);


  const saveToLocalStorage = (data: any) => {
    const saved = localStorage.getItem('add_member_form');
    const form = saved ? JSON.parse(saved) : {};
    localStorage.setItem('add_member_form', JSON.stringify({ ...form, ...data }));
  };

  const [relationship, setRelationship] = useState<RelationshipType | ''>(() => {
    let savedObj: AddMemberForm = {};
    try {
      const saved = localStorage.getItem('add_member_form');
      if (saved) savedObj = JSON.parse(saved);
    } catch {}
    return savedObj.relationship || '';
  });
  const [otherRelation, setOtherRelation] = useState(() => {
    let savedObj: any = {};
    try {
      const saved = localStorage.getItem('add_member_form');
      if (saved) savedObj = JSON.parse(saved);
    } catch {}
    return savedObj.otherRelation || '';
  });

  const handleNext = () => {
    let form = {};
    try {
      form = JSON.parse(localStorage.getItem('add_member_form') || '{}');
    } catch {
      form = {};
    }
    form.relationship = relationship;
    if (relationship === 7) {
      form.otherRelation = otherRelation;
    } else {
      delete form.otherRelation;
    }
    localStorage.setItem('add_member_form', JSON.stringify(form));
    if (relationship && relationship === 6) {
      navigate('/profile/family/add-member/pet-details');
    } else {
      navigate('/profile/family/add-member/form');
    }
  };

  return (
    <div className="profile-page-root flex flex-col" style={{ minHeight: 'calc(var(--vh, 1vh) * 100 - 128px)' }}>
      <FormHeader
        module="Family"
        memberInfo={memberInfo}
        title="Let’s start with your relationship"
        description='Start by choosing your relationship with them.'
      />
    <div className="flex-1">
      <MSpacer  />
      <div className="flex flex-col gap-[32px]">
        <MInputField
          label="How are they related to you?"
          showLabel
          placeholder="Not Answered"
          variant="Underlined"
          value={relationship ? relationshipOptionsForAddMember.find(opt => String(opt.value) === String(relationship))?.label : ''}
          onClick={() => setDrawerOpen(true)}
          icon={<IconCaretDownFilled size={16} />}
          showIcon
          readOnly
        />
        {relationship === 7 && (
          <MInputField
            label="What’s your relationship?"
            showLabel
            placeholder="Not Answered"
            variant="Underlined"
            value={otherRelation}
            onChange={e => {
              setOtherRelation(e.target.value);
              saveToLocalStorage({ otherRelation: e.target.value });
            }}
            maxLength={30}
          />
        )}
        <MDropDownDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          title="Select relationship"
          items={relationshipOptionsForAddMember.map(opt => ({ value: String(opt.value), label: opt.label }))}
          variant="single"
          selectedValues={relationship ? [String(relationship)] : []}
          onSelect={val => {
            const relStr = Array.isArray(val) ? val[0] : val;
            const relNum = parseInt(relStr);
            setRelationship(relNum);
            let form = {};
            try {
              form = JSON.parse(localStorage.getItem('add_member_form') || '{}');
            } catch {
              form = {};
            }
            form.relationship = relNum;
            if (relNum === 7) {
              form.otherRelation = otherRelation;
            } else {
              delete form.otherRelation;
            }
            localStorage.setItem('add_member_form', JSON.stringify(form));
            setDrawerOpen(false);
          }}
        />
        </div>
    </div>
      <div className="confirm-footer">
        <MButton
          size="lg"
          variant="filled"
          className="w-full"
          disabled={!relationship}
          onClick={handleNext}
        >
          Next
        </MButton>
      </div>
    </div>
  );
};

export default SelectRelationship;
